import React, { createContext, useContext } from 'react';

export interface ClassSettingsModalContextValue {
  openClassSettingsModal: () => void;
}

export const ClassSettingsModalContext = createContext<ClassSettingsModalContextValue | null>(null);

/** MainLayout 밖에서는 null. 호출부에서 null 체크 후 버튼 노출 */
export function useClassSettingsModal(): ClassSettingsModalContextValue | null {
  return useContext(ClassSettingsModalContext);
}
